import React from 'react';

const AccordionGroup = ({opened, toggle, keyIndex, question, children}) => {

    const onToggle = () => {
        toggle(opened, keyIndex);
    }
    
    return(
    <div>
        <div className={"accordion " + (opened ? 'opened': '') }>
            <div className="question" onClick={onToggle}>
                <span>{ question }</span>
            </div>
            <div className="answer">
                {children}
            </div>
        </div>
    </div>  
    );
}

export default AccordionGroup;